<template>
    <div>
        <h4 class="mb-4 text-center text-uppercase">Carrello</h4>
        <b-table id="checkout_table" hover flex responsive :items="getProductsInCart" striped
                 @row-clicked="item=>$set(item, '_showDetails', !item._showDetails)">
            <template v-slot:cell(elimina)="row">
                <b-button size="sm" v-on:click="onDelete(row.item)" class="mr-2" v-di variant="danger">Elimina
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <b-row class="mb-1">
                        <b-col sm="4" class="text-sm-right"><b>Articolo:</b></b-col>
                        <b-col>{{ row.item.articolo }}</b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col sm="4" class="text-sm-right"><b>Descrizione:</b></b-col>
                        <b-col>{{ row.item.descrizione }}</b-col>
                    </b-row>
                    <b-row class="mb-1">
                        <b-col sm="4" class="text-sm-right"><b>Cliente:</b></b-col>
                        <b-col>{{ row.item.cliente }}</b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="row.item.note.length > 0">
                        <b-col sm="4" class="text-sm-right"><b>Note:</b></b-col>
                        <b-col>{{ row.item.note }}</b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="row.item.priorita.length > 0">
                        <b-col sm="4" class="text-sm-right"><b>Priorita:</b></b-col>
                        <b-col>URGENTE</b-col>
                    </b-row>
                    <b-button size="md" v-on:click="onEdit(row.item)" class="mt-2" v-di variant="secondary">Modifica
                        articolo
                    </b-button>
                </b-card>
            </template>
        </b-table>
        <b-button type="button" v-on:click="confirmCheckout()" class="btn btn-lg btn-full-width" v-di variant="primary"
                  v-if="getProductsInCart.length > 0">
            <b-icon-cart-fill></b-icon-cart-fill>
            Conferma acquisto
        </b-button>
        <hr v-if="getProductsInCart.length > 0">
        <b-button type="button" v-on:click="onReset()" class="btn-lg btn-full-width" v-di variant="outline-danger"
                  v-if="getProductsInCart.length > 0">
            <b-icon-trash></b-icon-trash>
            Reset carrello
        </b-button>
        <br/><br/>
        <b-button type="button" v-on:click="onAddItem()" class="btn btn-lg btn-full-width" v-di
                  variant="outline-secondary">
            <b-icon-bag-plus></b-icon-bag-plus>
            Nuovo articolo
        </b-button>
        <br/>
        <br/>
    </div>
</template>

<script>
    import {router} from "../_helpers";
    import {mapActions, mapGetters} from "vuex";

    export default {
        data() {
            return {
                fields: [
                    {key: 'articolo', label: 'Articolo'},
                    {key: 'quantita', label: 'Qnt'},
                    {key: 'mag', label: 'Mag'},
                    {key: 'elimina', label: ''}
                ]
            }
        },
        computed: {
            ...mapGetters('cart', [
                'getProductsInCart',
            ]),
            getProductsInCart() {
                return this.$store.getters["cart/getProductsInCart"];
            }
        },
        methods: {
            ...mapActions('cart', ['resetProducts', 'removeProduct', 'checkout']),
            onAddItem() {
                router.push('/');
            },
            onEdit(item) {
                localStorage.setItem('edit', item.id);
                router.push('/');
            },
            onReset() {
                if (confirm('Sei sicuro di voler eliminare tutti gli articoli presenti nel carrello?')) {
                    this.resetProducts();
                }
            },
            confirmCheckout() {
                if (confirm('Sei sicuro di voler confermare l\'acquisto degli articoli presenti nel carrello?')) {
                    this.checkout(this.getProductsInCart);
                    this.resetProducts();
                }
            },
            onDelete(row) {
                if (confirm('Sei sicuro di voler eliminare l\'articolo ' + row.articolo + '?')) {
                    var self = this;
                    var i = 0;
                    this.getProductsInCart.map(function (item) {
                        if (item.id == row.id) {
                            self.removeProduct(i);
                        }
                        i++;
                    });
                }
            }
        }
    }
</script>